import { AppTheme } from '@meitu/saas-ui/es/theme';
import { getLocaleStore } from '@/i18n';
import { IEnhanceSlider } from '../types';

export const getSliderConfig = (theme = AppTheme.white) => {
    const { $t } = getLocaleStore();
    return [
        {
            featureType: 'light',
            name: $t((v) => v.mainLayer.enhance.config.highlight),
            keyName: 'highlight',
            maxVal: 100,
            minVal: -100,
            lightBackgroundClass: 'ga_1 ',
            lightWrapBackgroundClass: 'gg_2',
            darkBackgroundClass: 'ga_1',
            darkWrapBackgroundClass: 'gg_2',
        },
        {
            featureType: 'light',
            name: $t((v) => v.mainLayer.enhance.config.shadow),
            keyName: 'shadow',
            maxVal: 100,
            minVal: -100,
            lightBackgroundClass: 'ga_1',
            lightWrapBackgroundClass: 'ab_2',
            darkBackgroundClass: 'ga_1',
            darkWrapBackgroundClass: 'ab_2',
        },
        {
            featureType: 'light',
            name: $t((v) => v.mainLayer.enhance.config.fade),
            keyName: 'fade',
            maxVal: 100,
            minVal: -100,
            opacityOpposite: true,
            lightBackgroundClass: 'brt_1 ',
            lightWrapBackgroundClass: 'brt_2',
            darkBackgroundClass: 'brt_1',
            darkWrapBackgroundClass: 'brt_2',
        },
    ].map((item: IEnhanceSlider) => {
        theme = theme === AppTheme.dark ? AppTheme.dark : AppTheme.white;
        //底层背景
        item.background =
            theme == 'dark'
                ? item.darkBackgroundClass
                    ? { useStyle: true, classname: item.darkBackgroundClass }
                    : item.darkBackgroundImage
                : item.lightBackgroundClass
                  ? { useStyle: true, classname: item.lightBackgroundClass }
                  : item.lightBackgroundImage;

        //蒙版背景
        item.wrapBackground =
            theme == 'dark'
                ? item.darkWrapBackgroundClass
                    ? { useStyle: true, classname: item.darkWrapBackgroundClass }
                    : item.darkWrapBackgroundImage
                : item.lightWrapBackgroundClass
                  ? { useStyle: true, classname: item.lightWrapBackgroundClass }
                  : item.lightWrapBackgroundImage;
        return item;
    });
};
